/**
 * «1 оберт», «3 оберти», «5 обертів», «11 обертів» — відмінювання числа
 * обертів для лічильника на головній і в розділі колеса (owner 2026-09-24).
 */
export function spinsWord(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return "оберт";
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return "оберти";
  return "обертів";
}

export function spinsLabel(n: number): string {
  return `${n} ${spinsWord(n)}`;
}
